var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M5.77 11.5A6.25 6.25 0 1 1 12 18.25a.75.75 0 0 0 0 1.5 7.75 7.75 0 1 0-7.734-8.25h-.998a.5.5 0 0 0-.433.75l1.732 3a.5.5 0 0 0 .866 0l1.732-3a.5.5 0 0 0-.433-.75z",
    clipRule: "evenodd"
  })));
};
export default SvgReset;